import styled from "styled-components";

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  gap: 2rem;
`;
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;
`;
export const Title = styled.span`
  text-align: center;
  font-family: "Avenir";
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.07px;
`;

export const SubTitle = styled.span`
  color: #979797;
  font-family: "Avenir";
  font-size: 17px;
  text-align: center;
  font-weight: 500;
  letter-spacing: 0.07px;
`;

export const Input = styled.input`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 5px;
  width: 250px;

  font-family: "Avenir";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.08px;

  height: 4.5rem;

  background: #ededf9;
  border: 1px solid rgba(255, 255, 255, 0.15);
  -webkit-box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
  box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
  padding: 15px;
  border-radius: 20px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const Text = styled.span`
  color: ${(props) => (props.$green ? "#00B712" : "#484888")};
  font-family: "Avenir";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.178px;
`;

export const TextRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;
export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  border-radius: 4rem;
  padding: 1rem;
  box-shadow: 0px 4px 10px 0px rgba(45, 45, 67, 0.11);
`;

export const Button = styled.button`
  display: flex;
  width: 100%;
  height: 5.5rem;
  margin-top: 3rem;
  margin-bottom: 1rem;
  border-radius: 30px;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    ),
    #6868ac;
  box-shadow: 0px 12px 24px -6px rgba(81, 81, 145, 0.46);

  color: #fff;
  text-align: center;
  font-family: "Avenir";
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.1px;
  border: none;
  outline: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;

  transition: all 0.3s ease-in-out;
  &:active {
    scale: 0.95;
  }
`;

export const ChipInRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

export const ChipInText = styled.span`
  font-family: "Avenir";
  font-size: 16px;
  font-weight: 600;
`;
export const ChipInPrice = styled.span`
  font-family: "Avenir";
  font-size: 17px;
  font-weight: 500;
  color: ${(props) => (props.$red ? "#F00" : "#484888")};
`;
